// @flow

import * as at from '../actions/action-types';
// types
import type { PresignedPost } from '../modules/api/response-types/presigned-post';
import type { Action } from '../store';

export type State = PresignedPost | null;

export const initialState = null;

/* 🤔 could probably DRY this up by using a custom combineReducers or something */
export default (
  state: State = initialState,
  action: Action,
): State | PresignedPost => {
  switch (action.type) {
    case at.RESOURCE_RECEIVE:
      if (
        action.payload.method === 'PUT' &&
        action.payload.resourceName === 'PRESIGNED_POSTS'
      ) {
        return ((action.payload.data: any): PresignedPost);
      }

      return state;

    default:
      return state;
  }
};
